import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-mechanic-title',
  imports: [],
  templateUrl: './rid-mechanic-title.html',
  host: {
    class: 'block absolute top-8 w-full',
    'animate.enter': 'anim-fade-from-top',
    'animate.leave': 'anim-fade-to-top',
  },
})
export class RidMechanicTitle {
  title = input.required<string>();
}
